import { render, staticRenderFns } from "./ProductBind.vue?vue&type=template&id=5e2ac49d&scoped=true"
import script from "./ProductBind.vue?vue&type=script&lang=js"
export * from "./ProductBind.vue?vue&type=script&lang=js"
import style0 from "./ProductBind.vue?vue&type=style&index=0&id=5e2ac49d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ac49d",
  null
  
)

export default component.exports